module.exports = __webpack_public_path__ + "static/media/person_not_selected.6cd6b673.svg";